import React, { useContext } from 'react';
import { RefertoContext } from 'app/context/RefertoContext';
import AllergieForm from './AllergieForm';

const Allergie = ({ onClose }) => {
    const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
    const allergie = referto?.allergie;
    const handleAddNewAllergy = (newAllergy) => {
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "allergie",
            payload: newAllergy
        });
    };

    const handleCancella = () => {
        const allergie =({
            allergene: '',
            dataInizio: '',
            dataFine: '',
            agente: '',
            codAgente: '',
            reazione: '',
            codReazione: '',
            obiettivita: '',
            severita: '',
            stato: '',
            commento: '',
            tipoAllergia: 'OINT',
            tipoLabel: 'Intolleranza',
            severitaLabel: '',
            statoLabel: ''
        });
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "allergie",
            payload: allergie
        });
    };

    return (
        <div className="container">
            <div className="mt-4">
                <AllergieForm
                    initialData={allergie ?? {}}
                    onSubmit={handleAddNewAllergy}
                    onClose={onClose}
                    onCancel={handleCancella}
                />
            </div>
        </div>
    );
};

export default Allergie;
